import {observer} from 'mobx-react';
import React from 'react';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {SelectItem, TextItem} from '../../models';
import {ErrorItem} from '../models';
import {SelectQuestionEditStore} from '../SelectQuestionEditStore';

const noop = () => {
};

function renderItem(item: SelectItem | TextItem | ErrorItem, key: string | number) {
  if (item.type === 'text')
    return (<span className="text" key={key}>{item.content}</span>);

  if (item.type === 'select-error')
    return (
      <span className="bg-danger border-danger select invalid" key={key}>
        {item.message}
      </span>
    );

  if (item.type === 'select') {
    const index = item.choices.findIndex(x => x.selected);
    const value = index === -1 ? '' : index;
    return (
      <select className="select-question"
              value={value}
              key={key}
              onChange={noop}>
        {
          item.choices.map((choice, index) =>
            <option value={index} key={index}>{choice.label}</option>)
        }
      </select>
    );
  }
  return null;
}

function* renderer(store: SelectQuestionEditStore): ReactNodeGenerator {
  const model = store.model;
  for (let index = 0; index < model.paragraphs.length; index++) {
    let paragraph = model.paragraphs[index];

    yield (
      <div className="select-question-paragraph" key={index}>
        {
          paragraph.items.map(
            (item, index) => renderItem(item, index))
        }
      </div>);
  }

  if (store.selectStores.length === 0)
    yield (
      <div className="alert alert-info" key="no-selects">No selects</div>
    );
}

@observer
export class SelectQuestionPreview extends React.Component<{ store: SelectQuestionEditStore }> {
  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="select-question-preview">
            {Array.from(renderer(this.props.store))}
          </div>
        </div>
      </div>
    );
  }
}
